import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Grid } from '@mui/material';
import { MarketButton } from '@market/react';
import { fetchLocalizedComponent } from 'utilities/component_localization';
import { pushHistoryWithSearchParams } from 'components/pages/checkout/utilities';

const Fields = fetchLocalizedComponent('common/finance_app/fields');

const ApplicationForm = (props) => {
  const history = useHistory();
  const { t } = useTranslation();

  const { onSubmit, disabled, applicationData } = props;

  return (
    <>
      <Grid container spacing={2}>
        <Suspense fallback={null}>
          <Fields applicationData={applicationData} disabled={disabled} />
        </Suspense>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <MarketButton
            {...(disabled && { disabled: true })}
            id="change-installment-plan-btn"
            onClick={() =>
              pushHistoryWithSearchParams(history, '/offer_select')
            }
            style={{ width: '100%' }}
          >
            {t('checkout.label.changeInstallmentPlan')}
          </MarketButton>
        </Grid>
        <Grid item xs={12} md={6}>
          <MarketButton
            {...(disabled && { disabled: true })}
            id="submit-application-btn"
            rank="primary"
            onClick={onSubmit}
            style={{ width: '100%' }}
          >
            {t('checkout.label.submitApplication')}
          </MarketButton>
        </Grid>
      </Grid>
    </>
  );
};

export default ApplicationForm;
